import { GlobalResponseObject } from "../../global-response-object";
import { CountBySubCategoriesDetails } from "./countBySubCategories-details";


export class CountBySubCategoriesResponse extends GlobalResponseObject{
data?:CountBySubCategoriesDetails[];
constructor(status: boolean, intlCode: number, internalMessage: string, data?:CountBySubCategoriesDetails[]){
    super(status,intlCode,internalMessage)
    this.data = data;
}
}